import { render } from "./photoComponent.vue?vue&type=template&id=2a458a50"
import script from "./photoComponent.vue?vue&type=script&lang=js"
export * from "./photoComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__